import React from 'react';

import styles from './assets/styles/styles.module.scss';

import { ReactComponent as IconAdd } from './assets/icons/addition-icon.svg';
import { ReactComponent as IconSub } from './assets/icons/substraction-icon.svg';
// import { ReactComponent as IconDiv } from './assets/icons/division-icon.svg';
// import { ReactComponent as IconMult } from './assets/icons/multiplication-icon.svg';

class Cards extends React.Component {
  mainRef = React.createRef();

  async componentDidMount() {
    await this.mainRef.current.scrollIntoView();
    document.documentElement.scrollTop -= 180;
  }

  renderSign = (sign) => {
    switch(sign) {
      case '+':
        return <IconAdd />;
      case '-':
        return <IconSub />;
      default:
        return null;
    }
  };

  render() {
    const {
      number,
      sign,
      fadeIn
    } = this.props;
    return (
      <div className={styles.cards} ref={this.mainRef}>
        <div className={styles[`container${fadeIn ? '_fade-in' : '_fade-out'}`]}>
            <span className={styles.sign}>{this.renderSign(sign)}</span>
            <span className={styles.number}>{number}</span>
        </div>
      </div>
    );
  }
}

export default Cards;
